import React, { useState } from "react";
import { Collapse } from "react-bootstrap";
import { Link, useHistory, useLocation } from "react-router-dom";
import "../assets/CSS/Sidebar.css";
import Footer from "./Footer";
import ProfileInfo from "./ProfileInfo";

const AdminSidebar = () => {
  const [open, setOpen] = useState(false);

  const [liveChatSection, setLiveChatSection] = useState(false);
  const [learningSession, setLearningSession] = useState(false);
  const [fangroup, setFanGroup] = useState(false);
  const [meetupSession, setMeetupSession] = useState(false);
  const [promoVideoSession, setPromoVideoSession] = useState(false);
  const [souvenir, setSouvenir] = useState(false);
  const [greetingSession, setGreetingSession] = useState(false);

  const [promoVideos, setPromoVideos] = useState(false);
  const [schedule, setSchedule] = useState(false);
  const [post, setPost] = useState(false);
  const [qna, setQnA] = useState(false);

  const history = useHistory();

  //assigning location variable
  const location = useLocation();
  const { pathname } = location;
  const url = pathname.split("/superstar-admin/");

  return (
    <nav className="sb-sidenav accordion sb-sidenav-dark" id="sidenavAccordion">
      <div className="sb-sidenav-menu custom-nav-scroll">
        <div className="nav">
          <ProfileInfo />
          <div className="sb-sidenav-menu-heading custom-heading-menu">
            Core
          </div>

          <Link
            className={
              url[1] === "dashboard" ? "nav-link active-nav" : "nav-link"
            }
            to="/superstar-admin/dashboard"
          >
            <span className="">
              <i className="fa-solid fa-gauge"></i> Dashboard
            </span>
          </Link>

          <Link
            className={
              url[1] === "e-wallet" ? "nav-link active-nav" : "nav-link"
            }
            to="/superstar-admin/e-wallet"
          >
            <span className="">
              <i class="fa-solid fa-wallet"></i> E-Wallet
            </span>
          </Link>

          {/* schedule */}

          <div
            className="nav-link cursor-pointer"
            onClick={() => setSchedule(!schedule)}
            aria-controls="example-collapse-text"
            aria-expanded={schedule}
          >
            <div className="sb-nav-link-icon">
              <i className="fas fa-calendar-alt"></i>
            </div>
            Schedule
            {schedule ? (
              <i className="fa-solid fa-angle-up left"></i>
            ) : (
              <i className="fa-solid fa-angle-down left"></i>
            )}
          </div>
          <Collapse in={schedule}>
            <div id="example-collapse-text subcat">
              <Link
                className="AudAdmin nav-link"
                to="/superstar-admin/schedule-create"
              >
                <span className="child-cat">
                  <i className="fas fa-calendar-alt"></i> Schedule Create
                </span>
              </Link>
              <Link
                className={
                  url[1] === "/schedule-list"
                    ? "AudAdmin nav-link active-nav"
                    : "AudAdmin nav-link"
                }
                to="/superstar-admin/schedule-list"
              >
                <span className="child-cat">
                  <i className="fa fa-list"></i> Schedule List
                </span>
              </Link>
            </div>
          </Collapse>

          {/* superstars */}
          <Link
            className={
              url[1] === "superstars" ? "nav-link active-nav" : "nav-link"
            }
            to="/superstar-admin/superstars"
          >
            <span className="">
              <i className="fas fa-star"></i> Super Stars
            </span>
          </Link>

          {/* Post Start */}

          <div className="sb-sidenav-menu-heading custom-heading-menu">
            Promo Videos
          </div>
          <div
            className="nav-link cursor-pointer"
            onClick={() => setPromoVideos(!promoVideos)}
            aria-controls="example-collapse-text"
            aria-expanded={promoVideos}
          >
            <div className="sb-nav-link-icon">
              <i className="fas fa-video"></i>
            </div>
            Promo Videos
            {promoVideos ? (
              <i className="fa-solid fa-angle-up left"></i>
            ) : (
              <i className="fa-solid fa-angle-down left"></i>
            )}
          </div>
          <Collapse in={promoVideos}>
            <div id="example-collapse-text subcat">
              <Link
                className="AudAdmin nav-link"
                to="/superstar-admin/promo-videos"
              >
                <span className="child-cat">
                  <i className="fa-solid fa-gauge"></i> &nbsp; Dashboard
                </span>
              </Link>
              <Link
                className={
                  url[1] === "/upload/promoVideo"
                    ? "AudAdmin nav-link active-nav"
                    : "AudAdmin nav-link"
                }
                to="/superstar-admin/upload/promoVideo"
              >
                <span className="child-cat">
                  <i className="fas fa-edit" aria-hidden="true"></i> &nbsp;
                  Create
                </span>
              </Link>

              <Link
                className={
                  url[1] === "/pending/promoVideo"
                    ? "AudAdmin nav-link active-nav"
                    : "AudAdmin nav-link"
                }
                to="/superstar-admin/pending/promoVideo"
              >
                <span className="child-cat">
                  <i className="fa fa-spinner" aria-hidden="true"></i> &nbsp;
                  Pending
                </span>
              </Link>

              <Link
                className={
                  url[1] === "/approved/promoVideo"
                    ? "AudAdmin nav-link active-nav"
                    : "AudAdmin nav-link"
                }
                to="/superstar-admin/approved/promoVideo"
              >
                <span className="child-cat">
                  <i class="fa-brands fa-get-pocket"></i> &nbsp; Approved
                </span>
              </Link>

              <Link
                className={
                  url[1] === "/live/promoVideo"
                    ? "AudAdmin nav-link active-nav"
                    : "AudAdmin nav-link"
                }
                to="/superstar-admin/live/promoVideo"
              >
                <span className="child-cat">
                  <i class="fa-solid fa-satellite-dish"></i> &nbsp; Live
                </span>
              </Link>

              <Link
                className={
                  url[1] === "/rejected/promoVideo"
                    ? "AudAdmin nav-link active-nav"
                    : "AudAdmin nav-link"
                }
                to="/superstar-admin/rejected/promoVideo"
              >
                <span className="child-cat">
                  <i className="fa fa-trash"></i> &nbsp; Star Rejected
                </span>
              </Link>
            </div>
          </Collapse>

          <div
            className="nav-link cursor-pointer"
            onClick={() => setPost(!post)}
            aria-controls="example-collapse-text"
            aria-expanded={post}
          >
            <div className="sb-nav-link-icon">
              <i className="fa fa-book" aria-hidden="true"></i>
            </div>
            Post
            {post ? (
              <i className="fa-solid fa-angle-up left"></i>
            ) : (
              <i className="fa-solid fa-angle-down left"></i>
            )}
          </div>
          <Collapse in={post} className="childcat">
            <div id="example-collapse-text subcat">
              <Link
                className={
                  url[1] === "post/dashboard"
                    ? "AudAdmin nav-link active-nav"
                    : "AudAdmin nav-link"
                }
                to="/superstar-admin/post"
              >
                <span className="child-cat">
                  <i className="fa-solid fa-gauge"></i> &nbsp; Dashboard
                </span>
              </Link>

              <Link
                className={
                  url[1] === "post/create"
                    ? "AudAdmin nav-link active-nav"
                    : "AudAdmin nav-link"
                }
                to="/superstar-admin/post/create"
              >
                <span className="child-cat">
                  <i className="fas fa-edit"></i> &nbsp; Create
                </span>
              </Link>

              <Link
                className={
                  url[1] === "post/pending"
                    ? "AudAdmin nav-link active-nav"
                    : "AudAdmin nav-link"
                }
                to="/superstar-admin/post/pending"
              >
                <span className="child-cat">
                  <i className="fa fa-spinner" aria-hidden="true"></i> &nbsp;
                  Pending
                </span>
              </Link>

              <Link
                className={
                  url[1] === "post/approved"
                    ? "AudAdmin nav-link active-nav"
                    : "AudAdmin nav-link"
                }
                to="/superstar-admin/post/approved"
              >
                <span className="child-cat">
                  <i class="fa-solid fa-satellite-dish"></i> &nbsp; Live
                </span>
              </Link>
              <Link
                className={
                  url[1] === "post/reject"
                    ? "AudAdmin nav-link active-nav"
                    : "AudAdmin nav-link"
                }
                to="/superstar-admin/post/reject"
              >
                <span className="child-cat">
                  <i className="fas fa-trash"></i> &nbsp; Rejected
                </span>
              </Link>
            </div>
          </Collapse>

          {/* Post End */}

          <div className="sb-sidenav-menu-heading custom-heading-menu">
            Event Management
          </div>

          {/* liveChatSection */}
          <div
            className="nav-link cursor-pointer"
            onClick={() => setLiveChatSection(!liveChatSection)}
            aria-controls="example-collapse-text"
            aria-expanded={liveChatSection}
          >
            <div className="sb-nav-link-icon">
              <i className="far fa-comment-alt"></i>
            </div>
            Live Chat
            {liveChatSection ? (
              <i className="fa-solid fa-angle-up left"></i>
            ) : (
              <i className="fa-solid fa-angle-down left"></i>
            )}
          </div>
          <Collapse in={liveChatSection} className="childcat">
            <div id="example-collapse-text subcat">
              <Link
                className={
                  url[1] === "live-chat/dashboard"
                    ? "AudAdmin nav-link active-nav"
                    : "AudAdmin nav-link"
                }
                to="/superstar-admin/live-chat/dashboard"
              >
                <span className="child-cat">
                  <i className="fa-solid fa-gauge"></i> &nbsp; Dashboard
                </span>
              </Link>

              <Link
                className={
                  url[1] === "live-chat/create"
                    ? "AudAdmin nav-link active-nav"
                    : "AudAdmin nav-link"
                }
                to="/superstar-admin/live-chat/create"
              >
                <span className="child-cat">
                  <i className="fas fa-edit"></i> &nbsp; Create
                </span>
              </Link>

              <Link
                className={
                  url[1] === "live-chat/pending"
                    ? "AudAdmin nav-link active-nav"
                    : "AudAdmin nav-link"
                }
                to="/superstar-admin/live-chat/pending"
              >
                <span className="child-cat">
                  <i className="fa fa-spinner" aria-hidden="true"></i> &nbsp;
                  Pending
                </span>
              </Link>

              <Link
                className={
                  url[1] === "live-chat/live"
                    ? "AudAdmin nav-link active-nav"
                    : "AudAdmin nav-link"
                }
                to="/superstar-admin/live-chat/live"
              >
                <span className="child-cat">
                  <i class="fa-solid fa-satellite-dish"></i> &nbsp; Live
                </span>
              </Link>

              <Link
                className={
                  url[1] === "live-chat/completed"
                    ? "AudAdmin nav-link active-nav"
                    : "AudAdmin nav-link"
                }
                to="/superstar-admin/live-chat/completed"
              >
                <span className="child-cat">
                  <i class="fa-solid fa-clipboard-check"></i> &nbsp; Completed
                </span>
              </Link>
            </div>
          </Collapse>

          {/* QnA */}

          <div
            className="nav-link cursor-pointer"
            onClick={() => setQnA(!qna)}
            aria-controls="example-collapse-text"
            aria-expanded={qna}
          >
            <div className="sb-nav-link-icon">
              <i className="far fa-comment-alt"></i>
            </div>
            QnA
            {qna ? (
              <i className="fa-solid fa-angle-up left"></i>
            ) : (
              <i className="fa-solid fa-angle-down left"></i>
            )}
          </div>
          <Collapse in={qna} className="childcat">
            <div id="example-collapse-text subcat">
              <Link
                className={
                  url[1] === "qna/dashboard"
                    ? "AudAdmin nav-link active-nav"
                    : "AudAdmin nav-link"
                }
                to="/superstar-admin/qna/dashboard"
              >
                <span className="child-cat">
                  <i className="fa-solid fa-gauge"></i> &nbsp; Dashboard
                </span>
              </Link>

              <Link
                className={
                  url[1] === "qna/create"
                    ? "AudAdmin nav-link active-nav"
                    : "AudAdmin nav-link"
                }
                to="/superstar-admin/qna/create"
              >
                <span className="child-cat">
                  <i className="fas fa-edit"></i> &nbsp; Create
                </span>
              </Link>

              <Link
                className={
                  url[1] === "qna/pending"
                    ? "AudAdmin nav-link active-nav"
                    : "AudAdmin nav-link"
                }
                to="/superstar-admin/qna/pending"
              >
                <span className="child-cat">
                  <i className="fa fa-spinner" aria-hidden="true"></i> &nbsp;
                  Pending
                </span>
              </Link>

              <Link
                className={
                  url[1] === "qna/live"
                    ? "AudAdmin nav-link active-nav"
                    : "AudAdmin nav-link"
                }
                to="/superstar-admin/qna/live"
              >
                <span className="child-cat">
                  <i class="fa-solid fa-satellite-dish"></i> &nbsp; Live
                </span>
              </Link>

              <Link
                className={
                  url[1] === "qna/completed"
                    ? "AudAdmin nav-link active-nav"
                    : "AudAdmin nav-link"
                }
                to="/superstar-admin/qna/completed"
              >
                <span className="child-cat">
                  <i class="fa-solid fa-clipboard-check"></i> &nbsp; Completed
                </span>
              </Link>
              <Link
                className={
                  url[1] === "qna/rejected"
                    ? "AudAdmin nav-link active-nav"
                    : "AudAdmin nav-link"
                }
                to="/superstar-admin/qna/rejected"
              >
                <span className="child-cat">
                  <i className="fa fa-trash"></i> &nbsp; Rejected
                </span>
              </Link>
            </div>
          </Collapse>

          {/* End QnA */}

          {/* meetupSession */}
          <div
            className="nav-link cursor-pointer"
            onClick={() => setMeetupSession(!meetupSession)}
            aria-controls="example-collapse-text"
            aria-expanded={meetupSession}
          >
            <div className="sb-nav-link-icon">
              <i className="far fa-handshake"></i>
            </div>
            Meetup Session
            {meetupSession ? (
              <i className="fa-solid fa-angle-up left"></i>
            ) : (
              <i className="fa-solid fa-angle-down left"></i>
            )}
          </div>
          <Collapse in={meetupSession}>
            <div id="example-collapse-text subcat">
              <Link
                className={
                  url[1] === "meetup-events/dashboard"
                    ? "AudAdmin nav-link active-nav"
                    : "AudAdmin nav-link"
                }
                to="/superstar-admin/meetup-events/dashboard"
              >
                <span className="child-cat">
                  <i className="fa-solid fa-gauge"></i> &nbsp; Dashboard
                </span>
              </Link>
              <Link
                className={
                  url[1] === "meetup-events/create"
                    ? "AudAdmin nav-link active-nav"
                    : "AudAdmin nav-link"
                }
                to="/superstar-admin/meetup-events/create"
              >
                <span className="child-cat">
                  <i className="fas fa-edit"></i> &nbsp; Create
                </span>
              </Link>
              <Link
                className={
                  url[1] === "meetup-events/pending"
                    ? "AudAdmin nav-link active-nav"
                    : "AudAdmin nav-link"
                }
                to="/superstar-admin/meetup-events/pending"
              >
                <span className="child-cat">
                  <i className="fa fa-spinner" aria-hidden="true"></i> &nbsp;
                  Pending
                </span>
              </Link>
              <Link
                className={
                  url[1] === "meetup-events/live"
                    ? "AudAdmin nav-link active-nav"
                    : "AudAdmin nav-link"
                }
                to="/superstar-admin/meetup-events/live"
              >
                <span className="child-cat">
                  <i class="fa-solid fa-satellite-dish"></i> &nbsp; Live
                </span>
              </Link>
              <Link
                className={
                  url[1] === "meetup-events/completed"
                    ? "AudAdmin nav-link active-nav"
                    : "AudAdmin nav-link"
                }
                to="/superstar-admin/meetup-events/completed"
              >
                <span className="child-cat">
                  <i className="fa-solid fa-calendar"></i> &nbsp; Completed
                </span>
              </Link>
            </div>
          </Collapse>
          {/* nav item for greeting  */}
          <div
            className="nav-link cursor-pointer"
            onClick={() => setGreetingSession(!greetingSession)}
            aria-controls="example-collapse-text"
            aria-expanded={greetingSession}
          >
            <div className="sb-nav-link-icon">
              <i className="fas fa-tachometer-alt"></i>
            </div>
            Greetings
            {greetingSession ? (
              <i className="fa-solid fa-angle-up left"></i>
            ) : (
              <i className="fa-solid fa-angle-down left"></i>
            )}
          </div>
          <Collapse in={greetingSession}>
            <div id="example-collapse-text subcat">
              <Link
                className={
                  url[1] === "greetings"
                    ? "AudAdmin nav-link active-nav"
                    : "AudAdmin nav-link"
                }
                to="/superstar-admin/greetings"
              >
                <span className="child-cat">
                  <i className="fas fa-edit" aria-hidden="true"></i> &nbsp;
                  Create
                </span>
              </Link>
              <Link
                className={
                  url[1] === "greetings-all-request"
                    ? "AudAdmin nav-link active-nav"
                    : "AudAdmin nav-link"
                }
                to="/superstar-admin/greetings-all-request"
              >
                <span className="child-cat">
                  <i className="fas fa-list" aria-hidden="true"></i> &nbsp; New
                  request
                </span>
              </Link>
              <Link
                className={
                  url[1] === "greetings-registered-list"
                    ? "AudAdmin nav-link active-nav"
                    : "AudAdmin nav-link"
                }
                to="/superstar-admin/greetings-registered-list"
              >
                <span className="child-cat">
                  <i class="fa-solid fa-address-card"></i> &nbsp; Registered
                  list
                </span>
              </Link>
              <Link
                className={
                  url[1] === "greetings-completed-list"
                    ? "AudAdmin nav-link active-nav"
                    : "AudAdmin nav-link"
                }
                to="/superstar-admin/greetings-completed-list"
              >
                <span className="child-cat">
                  <i class="fa-solid fa-clipboard-check"></i> &nbsp; Completed
                  list
                </span>
              </Link>
              <Link
                className={
                  url[1] === "greetings-forwarded-list"
                    ? "AudAdmin nav-link active-nav"
                    : "AudAdmin nav-link"
                }
                to="/superstar-admin/greetings-forwarded-list"
              >
                <span className="child-cat">
                  <i class="fa-sharp fa-solid fa-share"></i> &nbsp; Forwarded List
                </span>
              </Link>
            </div>
          </Collapse>

          {/* learningSession */}
          <div
            className="nav-link cursor-pointer"
            onClick={() => setLearningSession(!learningSession)}
            aria-controls="example-collapse-text"
            aria-expanded={learningSession}
          >
            <div className="sb-nav-link-icon">
              <i className="fas fa-chalkboard-teacher"></i>
            </div>
            Learning Session
            {learningSession ? (
              <i className="fa-solid fa-angle-up left"></i>
            ) : (
              <i className="fa-solid fa-angle-down left"></i>
            )}
          </div>
          <Collapse in={learningSession}>
            <div id="example-collapse-text subcat">
              <Link
                className="AudAdmin nav-link"
                to="/superstar-admin/learning-session"
              >
                <span className="child-cat">
                  <i className="fa-solid fa-gauge"></i> &nbsp; Dashboard
                </span>
              </Link>

              <Link
                className={
                  url[1] === "learning-session/create"
                    ? "AudAdmin nav-link active-nav"
                    : "AudAdmin nav-link"
                }
                to="/superstar-admin/learning-session/create"
              >
                <span className="child-cat">
                  <i className="fas fa-edit"></i> &nbsp; Create
                </span>
              </Link>

              <Link
                className={
                  url[1] === "learning-session/pending"
                    ? "AudAdmin nav-link active-nav"
                    : "AudAdmin nav-link"
                }
                to="/superstar-admin/learning-session/pending"
              >
                <span className="child-cat">
                  <i className="fa fa-spinner" aria-hidden="true"></i> &nbsp;
                  Pending
                </span>
              </Link>

              <Link
                className={
                  url[1] === "learning-session/live"
                    ? "AudAdmin nav-link active-nav"
                    : "AudAdmin nav-link"
                }
                to="/superstar-admin/learning-session/live"
              >
                <span className="child-cat">
                  <i class="fa-solid fa-satellite-dish"></i> &nbsp; Live
                </span>
              </Link>

              <Link
                className={
                  url[1] === "learning-session/evaluation"
                    ? "AudAdmin nav-link active-nav"
                    : "AudAdmin nav-link"
                }
                to="/superstar-admin/learning-session/evaluation"
              >
                <span className="child-cat">
                  <i className="fa-solid fa-calendar"></i> &nbsp; Evaluation
                </span>
              </Link>

              <Link
                className={
                  url[1] === "learning-session/completed"
                    ? "AudAdmin nav-link active-nav"
                    : "AudAdmin nav-link"
                }
                to="/superstar-admin/learning-session/completed"
              >
                <span className="child-cat">
                  <i class="fa-solid fa-clipboard-check"></i> &nbsp; Completed
                </span>
              </Link>

              <Link
                className={
                  url[1] === "learning-session/result-main"
                    ? "AudAdmin nav-link active-nav"
                    : "AudAdmin nav-link"
                }
                to="/superstar-admin/learning-session/result-main"
              >
                <span className="child-cat">
                  <i className="fa-solid fa-square-poll-vertical"></i> &nbsp;
                  Result
                </span>
              </Link>
              <Link
                className={
                  url[1] === "learning-session/rejected"
                    ? "AudAdmin nav-link active-nav"
                    : "AudAdmin nav-link"
                }
                to="/superstar-admin/learning-session/rejected"
              >
                <span className="child-cat">
                  <i className="fa fa-trash"></i> &nbsp; Rejected
                </span>
              </Link>
            </div>
          </Collapse>

          {/* <div className="sb-sidenav-menu-heading custom-heading-menu">
            Audition Management
          </div>

          Audition
          <div
            className="nav-link cursor-pointer"
            onClick={() => setOpen(!open)}
            aria-controls="example-collapse-text"
            aria-expanded={open}
          >
            <div className="sb-nav-link-icon">
              <i className="far fa-handshake"></i>
            </div>
            Audition
            {open ? (
              <i className="fa-solid fa-angle-up left"></i>
            ) : (
              <i className="fa-solid fa-angle-down left"></i>
            )}
          </div>
          <Collapse in={open}>
            <div id="example-collapse-text subcat">
              <Link
                className="AudAdmin nav-link"
                to="/superstar-admin/audition/dashboard"
              >
                <span className="child-cat">
                  <i className="fa-solid fa-gauge"></i> &nbsp; Dashboard
                </span>
              </Link>
              <Link
                className={
                  url[1] === "/audition/live"
                    ? "AudAdmin nav-link active-nav"
                    : "AudAdmin nav-link"
                }
                to="/superstar-admin/audition/live"
              >
                <span className="child-cat">
                  <i class="fa-solid fa-satellite-dish"></i> &nbsp; Live Events
                </span>
              </Link>
            </div>
          </Collapse> */}

          {/* Star Showcase */}

          <div className="sb-sidenav-menu-heading custom-heading-menu">
            E-Showcase
          </div>

          <Link
            className={
              url[1] === "marketplace" ? "nav-link active-nav" : "nav-link"
            }
            to="/superstar-admin/marketplace"
          >
            <span className="">
              <i className="fa fa-line-chart" aria-hidden="true"></i>&nbsp;
              Marketplace
            </span>
          </Link>

          <div
            className="nav-link cursor-pointer"
            onClick={() => setSouvenir(!souvenir)}
            aria-controls="example-collapse-text"
            aria-expanded={souvenir}
          >
            <div className="sb-nav-link-icon">
              <i className="fas fa-video"></i>
            </div>
            Souvenir
            {souvenir ? (
              <i className="fa-solid fa-angle-up left"></i>
            ) : (
              <i className="fa-solid fa-angle-down left"></i>
            )}
          </div>
          <Collapse in={souvenir}>
            <div id="example-collapse-text subcat">
              <Link
                className={
                  url[1] === "/superstar-admin/souvenir"
                    ? "AudAdmin nav-link active-nav"
                    : "AudAdmin nav-link"
                }
                to="/superstar-admin/souvenir"
              >
                <span className="child-cat">
                  <i className="fa-solid fa-gauge"></i> &nbsp; Souvenir
                </span>
              </Link>
              <Link
                className={
                  url[1] === "/superstar-admin/souvenir"
                    ? "AudAdmin nav-link active-nav"
                    : "AudAdmin nav-link"
                }
                to="/superstar-admin/souvenir/registered"
              >
                <span className="child-cat">
                  <i className="fas fa-edit"></i> &nbsp; Registered Lists
                </span>
              </Link>

              <Link
                className={
                  url[1] === "/superstar-admin/souvenir"
                    ? "AudAdmin nav-link active-nav"
                    : "AudAdmin nav-link"
                }
                to="/superstar-admin/souvenir/payment/list"
              >
                <span className="child-cat">
                  <i class="fa-solid fa-cart-shopping"></i> &nbsp; User Order
                </span>
              </Link>
              <Link
                className={
                  url[1] === "/superstar-admin/souvenir"
                    ? "AudAdmin nav-link active-nav"
                    : "AudAdmin nav-link"
                }
                to="/superstar-admin/souvenir/payment/due-list"
              >
                <span className="child-cat">
                  <i class="fa-solid fa-money-check-dollar"></i> &nbsp; User Due
                  Payment
                </span>
              </Link>

              {/* <Link
                className={
                  url[1] === "/live/promoVideo"
                    ? "AudAdmin nav-link active-nav"
                    : "AudAdmin nav-link"
                }
                to="/superstar-admin/live/promoVideo"
              >
                <span className="child-cat">
                 <i className="fas fa-stream"></i> Live
                </span>
              </Link> */}
            </div>
          </Collapse>

          <Link
            className={
              url[1] === "auction" ? "nav-link active-nav" : "nav-link"
            }
            to="/superstar-admin/auction"
          >
            <span className="">
              <i className="fa fa-cart-plus" aria-hidden="true"></i>&nbsp;
              Auction
            </span>
          </Link>

          {/* End Starshowcase */}

          <div className="sb-sidenav-menu-heading custom-heading-menu">
            Others
          </div>

          {/* <div
            className="nav-link"
            onClick={() => setOpen(!open)}
            aria-controls="example-collapse-text"
            aria-expanded={open}
          >
            <div className="sb-nav-link-icon">
              <i className="fas fa-tachometer-alt"></i>
            </div>
            Audition
          </div>

          <Collapse in={open}>
            <div id="example-collapse-text">
              <Link
                className="nav-link"
                to="/superstar-admin/audition/dashboard"
              >
                <div className="sb-nav-link-icon">
                  <i className="fa-solid fa-circle"></i>
                </div>
                Dashboard
              </Link>
              <Link className="nav-link" to="/superstar-admin/audition/live">
                <div className="sb-nav-link-icon">
                  <i className="fa-solid fa-circle"></i>
                </div>
                Live Audition
              </Link>
              <Link className="nav-link" to="/superstar-admin/audition/pending">
                <div className="sb-nav-link-icon">
                  <i className="fa-solid fa-circle"></i>
                </div>
                Pending Audition
              </Link>
              <Link
                className="nav-link"
                to="/superstar-admin/audition/event/request-approve-view"
              >
                <div className="sb-nav-link-icon">
                  <i className="fa-solid fa-circle"></i>
                </div>
                Result
              </Link>

              <Link
                className="Link text-light"
                to="/superstar-admin/audition/round"
              >
                <p className="ms-3 PBtn me-3 p-2">Round</p>
              </Link>
              <Link className="Link text-light" to="">
                <p className="ms-3 PBtn me-3 p-2">Live Admins</p>
              </Link>
              <Link className="Link text-light" to="">
                <p className="ms-3 PBtn me-3 p-2">Jurys</p>
              </Link>
              <Link className="Link text-light" to="">
                <p className="ms-3 PBtn me-3 p-2">Result</p>
              </Link>
              <Link className="Link text-light" to="">
                <p className="ms-3 PBtn me-3 p-2">SuperStar</p>
              </Link>
              <Link className="Link text-light" to="">
                <p className="ms-3 PBtn me-3 p-2">SuperStar Admins</p>
              </Link>
              <Link className="Link text-light" to="">
                <p className="ms-3 PBtn me-3 p-2">Register User List</p>
              </Link>
              <Link className="Link text-light" to="">
                <p className="ms-3 PBtn me-3 p-2">Selected User List</p>
              </Link>
              <Link className="Link text-light" to="">
                <p className="ms-3 PBtn me-3 p-2">Rejected User List</p>
              </Link>
              <Link
                className="Link text-light"
                to="/superstar-admin/audition/certificate-create"
              >
                <p className="ms-3 PBtn me-3 p-2">Certificate</p>
              </Link>
            </div>
          </Collapse> */}

          {/* Fan Group */}
          <div
            className="nav-link cursor-pointer"
            onClick={() => setFanGroup(!fangroup)}
            aria-controls="example-collapse-text"
            aria-expanded={fangroup}
          >
            <div className="sb-nav-link-icon">
              <i className="fas fa-chalkboard-teacher"></i>
            </div>
            Fan Group
            <i className="fa-solid fa-angle-down left"></i>
          </div>
          <Collapse in={fangroup}>
            <div id="example-collapse-text subcat">
              <Link
                className={
                  url[1] === "fan-group"
                    ? "AudAdmin nav-link active-nav"
                    : "AudAdmin nav-link"
                }
                to="/superstar-admin/fan-group"
              >
                <span className="child-cat">
                  <i className="fa-solid fa-gauge"></i> &nbsp; Dashboard
                </span>
              </Link>

              <Link
                className={
                  url[1] === "create-fan-group"
                    ? "AudAdmin nav-link active-nav"
                    : "AudAdmin nav-link"
                }
                to="/superstar-admin/create-fan-group"
              >
                <span className="child-cat">
                  <i className="fas fa-edit"></i> &nbsp; Create
                </span>
              </Link>

              <Link
                className={
                  url[1] === "pending-fan-group"
                    ? "AudAdmin nav-link active-nav"
                    : "AudAdmin nav-link"
                }
                to="/superstar-admin/pending-fan-group"
              >
                <span className="child-cat">
                  <i className="fa fa-spinner" aria-hidden="true"></i> &nbsp;
                  Pending
                </span>
              </Link>

              <Link
                className={
                  url[1] === "fan-group-live"
                    ? "AudAdmin nav-link active-nav"
                    : "AudAdmin nav-link"
                }
                to="/superstar-admin/fan-group-live"
              >
                <span className="child-cat">
                  <i class="fa-solid fa-satellite-dish"></i> &nbsp; Live
                </span>
              </Link>

              <Link
                className={
                  url[1] === "approved-fan-group"
                    ? "AudAdmin nav-link active-nav"
                    : "AudAdmin nav-link"
                }
                to="/superstar-admin/approved-fan-group"
              >
                <span className="child-cat">
                  <i class="fa-solid fa-clipboard-check"></i> &nbsp; Approved
                </span>
              </Link>
            </div>
          </Collapse>

          {/* <Link className="nav-link" to="/superstar-admin/upcoming-event">
            <div className="sb-nav-link-icon">
              <i className="fas fa-tachometer-alt"></i>
            </div>
            Upcoming Events
          </Link> */}

          <div className="sb-sidenav-menu-heading custom-heading-menu">
            My Account
          </div>

          {/* <Link className="nav-link" to="/superstar-admin/wallet">
            <div className="sb-nav-link-icon">
              <i className="fas fa-tachometer-alt"></i>
            </div>
            Wallet
          </Link> */}
          <Link className="nav-link" to="/superstar-admin/profile-settings">
            <div className="sb-nav-link-icon">
              <i className="fas fa-tachometer-alt"></i>
            </div>
            Settings
          </Link>
        </div>
      </div>

      <Footer />
    </nav>
  );
};

export default AdminSidebar;
